export const FixedSpace = (props: {
  height?: number | string;
  width?: number | string;
  backgroundColor?: string;
}) => <div style={{ ...props ,maxHeight:props.height,maxWidth:props.width}} />;
